import React, { useEffect, useContext, useState } from 'react';
import RegionalMarketingItems from '../Presentation/RegionalMarketingItems';
import {
  modifyData,
  orderBtnAnalytics,
  clickImageAnalytics,
  getFilteredCarausalData,
} from '../MarketingUtilities/marketingUtils';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import MARKETING_HERO_CONSTANTS from '../Constants/MarketingConstants';
import { UserOrderContext } from 'context/context';

import { useSelector } from 'react-redux';
import { isMobileDeviceOnly, isTabletDevice, isCateringDisposition } from 'common/utilities/utils';
import { LOCAL_STORAGE_KEYS, HTTPS_URL, RESIZE } from 'common/constants/SharedConstants';
const { CAROUSELIMAGECLICK } = MARKETING_HERO_CONSTANTS;
export const analyticsImageClick = (analyticsData, index, item, currencyShortName, orderNowClick) => {
  clickImageAnalytics(analyticsData, index, item, currencyShortName);
  orderNowClick(analyticsData, index, CAROUSELIMAGECLICK, item);
};
export const RegionalMarketingComponent = props => {
  const { contentData = {}, history, userParams = {} } = props;
  const { carousalContent = '', animationSpeed } = contentData;
  const { DISPOSITION_DATA, SELECTED_TILE } = MARKETING_HERO_CONSTANTS;
  const { SELECTED_TILE_DATA, SET_REDIRECTION_PATH, UPDATE_CATERING_RETAIL_MENU_ALERT } = START_ORDER_CONSTANTS;
  const { MENU_NAVALERT_TITLE, MENU_NAVALERT_SUBTITLE } = TRANSLATE_MAPPING_KEY;
  const appStateReducer = useSelector(data => data.appStateReducer);
  const { localized } = appStateReducer?.userStatus;
  const dispositionNew = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW));
  const type = localStorage.getItem(LOCAL_STORAGE_KEYS.SERVICE_TYPE);
  const { store } = dispositionNew ? dispositionNew : MARKETING_HERO_CONSTANTS.localizedUserSampleData;
  const { id: storeId = '', name, summary } = store;
  const { value: storeName = '' } = name[0];
  const carauselFilteredData =
    (carousalContent && getFilteredCarausalData(carousalContent, type, storeId, storeName, summary)) || [];
  const carauselContent = carauselFilteredData && modifyData(carauselFilteredData);
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const profileReducer = useSelector(data => data.profileReducer);
  const [isMobile, setMobileHeader] = useState(isMobileDeviceOnly(window.innerWidth));
  const [isTablet, setTabletHeader] = useState(isTabletDevice(window.innerWidth));
  const { currencyShortName } = tenantReducer;
  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDeviceOnly(window.innerWidth);
    setMobileHeader(isMobileView);
    const isTabletView = isTabletDevice(window.innerWidth);
    setTabletHeader(isTabletView);
  };

  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile, isTablet]);

  const orderNowClick = (analyticsData, index, clickFlag, item) => {
    clickFlag !== CAROUSELIMAGECLICK && clickImageAnalytics(analyticsData, index, item, currencyShortName);
    if (item?.externalUrl?.includes(HTTPS_URL)) {
      window.open(item?.externalUrl);
    } else {
      if (!localized) {
        userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
        userOrderStateDispatch({ type: SET_REDIRECTION_PATH, value: { redirectionOrder: item.linkTo } });
      } else if (isCateringDisposition(dispositionNew?.type)) {
        userOrderStateDispatch({
          type: UPDATE_CATERING_RETAIL_MENU_ALERT,
          value: {
            flag: true,
            pathname: item.linkTo,
            title: MENU_NAVALERT_TITLE,
            contentMsg: MENU_NAVALERT_SUBTITLE,
          },
        });
      } else {
        if (clickFlag !== CAROUSELIMAGECLICK) {
          clickImageAnalytics(analyticsData, index);
        }

        orderBtnAnalytics(analyticsData, index);
        userOrderStateDispatch({
          type: SELECTED_TILE_DATA,
          value: {
            selectedData: {
              name: item.name,
            },
          },
        });
        localStorage.setItem(
          SELECTED_TILE,
          JSON.stringify({
            name: item.name,
          }),
        );
        history.push({
          pathname: `${item.linkTo}`, //use linkTo
        });
      }
    }
  };

  return (
    <div className='market-hero-global-aus'>
      {carauselContent.length > 0 && (
        <RegionalMarketingItems
          contentData={carauselContent}
          animationSpeed={animationSpeed}
          clickHandler={orderNowClick}
          clickImageAnalytics={analyticsImageClick}
          isMobile={isMobile}
          tenantReducer={tenantReducer}
          profileReducer={profileReducer}
          userParams={userParams}
          isTablet={isTablet}
        />
      )}
    </div>
  );
};

export default RegionalMarketingComponent;
